module.exports = {
  servicesHostName: 'https://dindin-preprod-api.dindin-internal.com/api/'
  // servicesHostName: 'http://localhost:8000/api/'
}
